import type { ModernSubscription } from '../../types';
import { SubscriptionStates } from '../../types';

export function isModernSubscriptionTrial(subscription: ModernSubscription): boolean {
  const { state } = subscription;
  return [
    SubscriptionStates.ACTIVE_TRIAL,
    SubscriptionStates.GRACE_PERIOD_TRIAL,
    SubscriptionStates.LAPSED_TRIAL,
  ].includes(state as SubscriptionStates);
}
